<template>
  <div class="user-center-temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>个人中心模板</div>
      <ul class="flex header-list">
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
      </ul>
    </div>
    <div class="flex">
      <!-- 组件容器 -->
      <div class="component-list">
        <div class="title">基础组件</div>
        <div class="dragArea list-group flex flex-wrap">
          <template v-for="(v, i) in hmComponents">
            <div class="list-group-item" v-if="v.type === 'base'" :key="i">
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </div>
        <div class="title">营销组件</div>
        <div class="dragArea list-group flex flex-wrap">
          <template v-for="(v, i) in hmComponents">
            <div
              class="list-group-item"
              v-if="v.type === 'marketing'"
              :key="'i' + i"
            >
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </div>
      </div>
      <!-- 预览容器 -->
      <div class="preview-container">
        <div class="preview-wrapper">
          <div class="preview-head">
            <div class="preview-title">{{ title }}</div>
          </div>
          <div class="preview-body">
            <el-scrollbar>
              <div class="dragArea preview-list-group">
                <div class="info">
                  <div class="info-img-wrapper">
                    <img
                      class="img flex"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190904141253.png"
                      alt
                    />
                    <div class="card-no">
                      <span v-show="tabBarList.showCardNo"
                        >卡号：9600000087</span
                      >
                      <div v-show="tabBarList.showPhone">151*****323</div>
                    </div>
                  </div>
                  <div class="white-bg" v-show="!tabBarList.showInterest"></div>
                  <div
                    class="white-bg-type"
                    v-show="!tabBarList.showCardType"
                  ></div>
                </div>
                <div
                  class="member-info"
                  :class="{ 'no-card': !tabBarList.showCard }"
                >
                  <div class="info flex flex-around">
                    <template v-for="(v, i) in tabBarList.basInfoList">
                      <div v-if="v.visible" :key="i">
                        <div class="content">{{ v.content }}</div>
                        <div class="name">{{ v.name }}</div>
                      </div>
                    </template>
                  </div>
                  <div class="member-card" v-if="tabBarList.showCard">
                    <img class="img" :src="tabBarList.plusBg" alt="背景图" />
                    <div class="plus-start-day" :style="{color: tabBarList.plusStartDescColor}" v-if="tabBarList.plusStartShow">{{tabBarList.plusStartDesc}}365天</div>
                    <button v-if="tabBarList.cardText">{{ tabBarList.cardText }}</button>
                  </div>
                </div>
                <!-- <div class="radius" v-if="tabBarList.showCard">
                  <img
                    class="img"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/hu(1).png"
                    alt
                  />
                </div> -->
                <!-- <div class="order-list">
                  <img
                    class="img flex"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903141904.png"
                    alt
                  />
                </div> -->
                <div
                  class="preview-list-group-item"
                  @click="selectPreviewItem(i, v.prop)"
                  :class="{
                    active: activePreviewIndex === i,
                    mb50: i === previewComponents.length - 1
                  }"
                  v-for="(v, i) in previewComponents"
                  :key="i"
                >
                  <div class="orderList-wrapper" v-if="v.component === 'orderList'">
                    <div class="flex flex-between">
                      <div class="orderList-title">我的订单列表</div>
                      <div class="orderList-subtitle">查看更多订单<span class="hmicon icon-youjiantou"></span></div>
                    </div>
                    <div class="flex flex-between">
                      <div class="orderList-item flex flex-center flex-column item-center" v-for="(item, index) in v.prop.orderList" :key="index" v-if="item.state !== 'offlineOrder'">
                        <div class="orderList-src">
                          <img
                            style="width: 100%;"
                            :src="item.src"
                            v-if="item.src"
                            alt="图片广告"
                          />
                        </div>
                        <div>
                          {{ item.hrefName }}
                        </div>
                      </div>                      
                    </div>
                    <div v-for="(item, index) in v.prop.orderList" :key="index">
                      <div class="orderList-offlineOrder flex flex-between item-center" v-if="item.state === 'offlineOrder' && item.isShow">
                        <div class="flex item-center">
                          <div class="orderList-src">
                            <img
                              style="width: 100%;"
                              :src="item.src"
                              v-if="item.src"
                              alt="图片广告"
                            />
                          </div>
                          <div>
                            {{ item.hrefName }}
                          </div>
                        </div>
                        <span class="hmicon icon-youjiantou"></span>
                      </div>
                    </div>
                  </div>
                  <div class="banner-wrapper" v-if="v.component === 'banner'">
                    <img
                      v-if="!v.prop.imgList.length"
                      class="img flex"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903142717.png"
                      alt
                    />
                    <el-carousel
                      arrow="never"
                      trigger="click"
                      height="77px"
                      v-if="v.prop.imgList.length"
                    >
                      <el-carousel-item
                        v-for="(v, i) in v.prop.imgList"
                        :key="i"
                      >
                        <img class="img" :src="v.src" alt="图片广告" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div v-if="tabBarList.showJoinGroup && i === 1">
                    <div
                      class="join-group-wrapper"
                      v-show="tabBarList.showJoinGroup"
                    >
                      <img :src="tabBarList.joinGroupBg" alt />
                    </div>
                  </div>
                  <div v-if="v.component === 'myService'">
                    <div
                      class="service-list-card"
                      :class="{ vertical: v.prop.isVertical }"
                    >
                      <div class="title" v-if="!v.prop.isVertical">
                        我的服务
                      </div>
                      <div class="service-list">
                        <template v-for="(item, i) in v.prop.serviceList">
                          <div class="list-item" :key="i" v-if="item.show">
                            <div class="icon-wrapper">
                              <img class="icon" :src="item.icon" />
                              <div>{{ item.name }}</div>
                            </div>
                            <div class="icon-wrapper" v-if="v.prop.isVertical">
                              <span class="hmicon icon-youjiantou"></span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="widget">
                    <span class="widget-label">{{ v.label }}</span>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="tabbar">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903120009.png"
              alt="tabbar"
            />
          </div>
          <div class="preview-height-tag">
            <span class="preview-height-tag-text">iPhone 8手机高度</span>
          </div>
        </div>
      </div>
      <!-- 设置项容器 -->
      <div class="options-container">
        <!-- 全局设置 -->
        <div class="page-setting" v-if="showPageSetting">
          <div class="page-header">
            <div class="title">个人中心</div>
            <div class="tips">添加会员卡背景图(建议尺寸1500x720)</div>
            <div>
              <div class="sub-title">顶部栏设置</div>
              <div class="flex item-center">
                <span class="mr10">页面名称</span>
                <el-input
                  class="flex-1"
                  size="small"
                  v-model="title"
                  placeholder="顶部栏标题"
                ></el-input>
              </div>
            </div>
          </div>
          <ul class="other-setting p20">
            <!-- 基础显示 -->
            <li class="flex flex-between item-center">
              <span class="mr20">权益说明</span>
              <div class="flex-1 flex flex-end">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showInterest"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">会员卡</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showCard"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">会员卡自定义文字</span>
              <div class="flex flex-end flex-1">
                <el-input v-model="tabBarList.cardText" size="small"></el-input>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">会员卡自定义跳转</span>
              <div class="flex flex-end flex-1">
                <el-select
                  class="flex-1"
                  size="small"
                  clearable
                  placeholder="选择页面"
                  v-model="tabBarList.hrefAddress"
                  filterable
                  @change="selectGroup($event, i)"
                >
                  <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                  ></el-option>
                </el-select>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">入会天数</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.plusStartShow"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">入会天数文字</span>
              <div class="flex flex-end flex-1 mr10">
                <el-input
                  size="small"
                  v-model="tabBarList.plusStartDesc"
                ></el-input>
              </div>
              <el-color-picker
                :predefine="[tabBarList.plusStartDescColor]"
                v-model="tabBarList.plusStartDescColor"
                size="mini"
              ></el-color-picker>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">主卡类型</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showCardType"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">会员卡号</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showCardNo"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">会员手机号</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showPhone"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <span class="mr20">加入群聊</span>
              <div class="flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showJoinGroup"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <!-- 带参数的类型 -->
            <li
              class="flex flex-between item-center"
              v-for="(v, i) in tabBarList.basInfoList"
              :key="i"
            >
              <el-input v-model="v.name" size="small"></el-input>
              <el-switch
                :width="30"
                v-model="v.visible"
                active-color="#13ce66"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </li>
          </ul>
          <div class="have-bg-wrapper">
            <div class="plus-bg-wrapper pointer" @click="uploadPlusBg">
              <img :src="tabBarList.plusBg" alt="plus会员背景" />
              <div class="tip">更换会员背景图片</div>
            </div>
          </div>
          <!-- <ul class="other-setting p20">
           
            <li class="flex flex-between item-center">
              <div>
                <span class="mr20">品牌卡余额</span>
                <span class="sub-title temp">{{
                  tabBarList.showBrandCardBalance ? "显示" : "隐藏"
                }}</span>
              </div>
              <div class="item-setting flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showBrandCardBalance"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
            <li class="flex flex-between item-center">
              <div>
                <span class="mr20">品牌卡数量</span>
                <span class="sub-title temp">{{
                  tabBarList.showBrandCardCount ? "显示" : "隐藏"
                }}</span>
              </div>
              <div class="item-setting flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showBrandCardCount"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
          </ul> -->
        </div>
        <!-- 单个组件设置 -->
        <div class="component-setting" v-if="!showPageSetting">
          <!-- 广告图设置 -->
          <div
            class="banner-setting"
            v-if="currentProp && currentProp.name === 'orderList'"
          >
            <div class="p20">
              <div class="title">我的订单列表</div>
              <div class="tips">
                图标风格需保持一致(建议储存76x76）
              </div>
            </div>
            <draggable :list="currentProp.orderList">
              <ul class="tabbar-setting">
                <li
                  class="tabbar-setting-item flex item-center"
                  v-for="(v, i) in currentProp.orderList"
                  :key="i"
                >
                  <!-- <div class="delete-tab" @click="deleteCurrentImageOrder(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div> -->
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageOrder(i)"
                  >
                    <img
                      style="width: 100%;"
                      :src="v.src"
                      v-if="v.src"
                      alt="标签"
                    />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1 flex-column">
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">标题</span>
                      <el-input
                        size="small"
                        type="text"
                        style="width: 120px"
                        v-model="v.hrefName"
                        maxlength="6"
                        >{{ v.hrefName }}</el-input
                      >
                      <el-switch
                        :width="30"
                        v-model="v.isShow"
                        active-color="#13ce66"
                        :active-value="true"
                        :inactive-value="false"
                        v-if="v.state==='offlineOrder'"
                        style="margin-left:20px"
                      ></el-switch>
                    </div>
                    <div class="flex item-center">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        filterable
                        @change="selectGroupOrder($event, i)"
                      >
                        <el-option
                          v-for="(item, i) in selectOrderList"
                          :key="i"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </li>
              </ul>
            </draggable>
            
            
          </div>
          <!-- 广告图设置 -->
          <div
            class="banner-setting"
            v-if="currentProp && currentProp.name === 'banner'"
          >
            <div class="p20">
              <div class="title">广告位</div>
              <div class="tips">
                添加广告图建议尺寸1380x304，可不添加，最多添加三张
              </div>
            </div>
            <draggable :list="currentProp.imgList">
              <ul class="tabbar-setting">
                <li
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.imgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img
                      style="width: 100%"
                      :src="v.src"
                      v-if="v.src"
                      alt="图片广告"
                    />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">链接类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        @change="openGoodsSelect(v, i, 'imgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        filterable
                        v-if="!v.groupGoods.groupId"
                        @change="selectGroup($event, i)"
                      >
                        <el-option
                          v-for="(item, i) in microShopRouteList"
                          :key="i"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup(i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </draggable>
            <el-button
              type="primary"
              @click="addImageAd"
              plain
              :disabled="currentProp && currentProp.imgList.length >= 3"
              size="small"
              class="w100"
              >添加广告图</el-button
            >
          </div>
          <!-- 加入群聊背景图 -->
          <div
            class="banner-setting"
            v-if="currentProp && currentProp.name === 'joinGroup'"
          >
            <div class="p20">
              <div class="title">加入群聊</div>
              <div class="tips">
                添加广告图建议尺寸1380x304，可不添加，最多添加三张
              </div>
            </div>
            <div class="have-bg-wrapper">
              <div
                class="plus-bg-wrapper join-bg pointer"
                @click="uploadPlusBg('joinGroupBg')"
              >
                <img :src="tabBarList.joinGroupBg" alt="加入群聊背景" />
                <div class="tip">更换加入群聊背景图片</div>
              </div>
            </div>
          </div>
          <!-- 我的服务设置 -->
          <div
            class="service-setting"
            v-if="currentProp && currentProp.name === 'myService'"
          >
            <div class="p20">
              <div class="title">我的服务</div>
              <div class="tips">图标风格需保持一致(建议尺寸76x76)</div>
            </div>
            <div class="other-setting">
              <div class="flex flex-between item-center radio-wrapper">
                <div class="flex">
                  <span class="mr20">排列样式</span>
                  <span class="sub-title temp">{{
                    currentProp.isVertical ? "列表布局" : "水平布局"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.isVertical">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.isVertical }"
                      >
                        <span class="hmicon icon-wangge"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.isVertical }"
                      >
                        <span class="hmicon icon-liebiaobuju"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="flex flex-between item-center radio-wrapper">
                <div class="label" style="margin-right:10px">字号大小</div>
                <div>
                  <el-radio-group
                    v-model="currentProp.fontSizeType"
                    class="flex-1"
                    style="border:none"
                  >
                    <el-radio label="small" style="margin-right:14px;"><span style="margin-left:4px;">小号</span></el-radio>
                    <el-radio label="normal" style="margin-right:14px;"><span style="margin-left:4px;">正常</span></el-radio>
                  </el-radio-group>
                </div>
              </div>
              <draggable class="tabbar-setting" :list="currentProp.serviceList">
                <div
                  class="tabbar-setting-item move"
                  v-for="(item, i) in currentProp.serviceList"
                  :key="i"
                >
                  <div
                    class="delete-tab"
                    v-if="item.custom"
                    @click="deleteCurrentService(i)"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex">
                    <div class="navbar-icon flex">
                      <div class="un-selected flex">
                        <div
                          class="icon-wrapper"
                          :class="{ 'no-bg': !item.icon }"
                          @click="uploadServiceImg(i)"
                        >
                          <img :src="item.icon" alt="图标" />
                          <div class="change-icon">
                            {{ item.icon ? "更换图标" : "添加图标" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="flex flex-between">
                        <div class="flex item-center mb10">
                          <span class="mr10">标题</span>
                          <el-input
                            size="small"
                            type="text"
                            style="width: 120px"
                            v-model="item.name"
                            >{{ item.name }}</el-input
                          >
                        </div>
                        <div class="flex flex-between">
                          <!-- <span>{{ item.show ? "显示" : "隐藏" }}</span> -->
                          <el-switch
                            :width="30"
                            v-model="item.show"
                            active-color="#13ce66"
                            :active-value="true"
                            :inactive-value="false"
                          ></el-switch>
                        </div>
                      </div>
                      <div class="link">
                        <span class="mr10">链接</span>
                        <el-select
                          :disabled="!item.custom"
                          class="flex-1"
                          size="small"
                          clearable
                          allow-create
                          placeholder="选择页面"
                          v-model="item.hrefAddress"
                          filterable
                        >
                          <template v-for="(item, i) in microShopRouteList">
                            <el-option
                              :key="i"
                              v-if="item.hrefAddress !== 'groupGoods'"
                              :label="item.hrefName"
                              :value="item.hrefAddress"
                            ></el-option>
                          </template>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
              <div class="add-navigation">
                <el-button
                  type="primary"
                  @click="addServiceList"
                  plain
                  :disabled="
                    currentProp.serviceList &&
                      currentProp.serviceList.length >= 21
                  "
                  size="small"
                  class="w100"
                  >添加导航</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开启全局设置按钮 -->
      <div
        class="page-setting-btn"
        @click="openPageSetting"
        :class="{ active: showPageSetting }"
      >
        <span class="hmicon icon-yemianshezhi"></span>
        <span>页面设置</span>
      </div>
    </div>

    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="uploadWidth"
      :height="uploadHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
  </div>
</template>

<script>
/* eslint vue/no-unused-components: [0] */
import { hmComponents, predefine } from "@/utils/tempData";
import html2canvas from "html2canvas";
import myUpload from "vue-image-crop-upload";
import draggable from "vuedraggable";
import HmRichEditor from "@/components/HmRichEditor";
import tabBar from "@/components/HmMallComponent/tabBar";
import search from "@/components/HmMallComponent/search";
import notice from "@/components/HmMallComponent/notice";
import contactUs from "@/components/HmMallComponent/contactUs";
import dividingLine from "@/components/HmMallComponent/dividingLine";
import richText from "@/components/HmMallComponent/richText";
import titleText from "@/components/HmMallComponent/titleText";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import imageTextNav from "@/components/HmMallComponent/imageTextNav";
import goodsList from "@/components/HmMallComponent/goodsList";
import cube from "@/components/HmMallComponent/cube";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import { mapGetters } from "vuex";
export default {
  display: "Clone",
  order: 2,
  components: {
    tabBar,
    search,
    contactUs,
    dividingLine,
    myUpload,
    notice,
    richText,
    HmRichEditor,
    titleText,
    imageAdSelection,
    imageTextNav,
    goodsList,
    cube,
    HmFilterMicroShopGoods,
    draggable,
    HmFilterGroupGoods
  },
  data() {
    return {
      groupGoodsVisible: false,
      isRadio: false,
      goodsType: "",
      tabBarList: {
        plusBg:
          "https://imgcdn.hemiao100.com/hemiaoBase/%E5%88%86%E7%BB%84.png",
        joinGroupBg:
          "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/3be3fd8810876be51a4a9cacc905b5b.png",
        showInterest: true,
        showCard: true,
        cardText: "我的会员卡",
        hrefAddress: "",
        showCardNo: true,
        showPhone: true,
        showCardType: true,
        showJoinGroup: true,
        basInfoList: [
          {
            name: "主卡积分",
            key: "currentIntegral",
            value: "",
            visible: true,
            content: "888",
            type: "score"
          },
          {
            name: "线上积分",
            key: "onlineIntegral",
            value: "",
            visible: true,
            content: "888",
            type: "score"
          },
          {
            name: "会员卡余额",
            key: "currentBalance",
            value: "",
            visible: true,
            content: "￥100",
            type: "money"
          },
          {
            name: "优惠券",
            key: "couponNum",
            value: "",
            visible: true,
            content: "5",
            type: "score"
          },
          {
            name: "金豆数",
            key: "goldBeanInfo",
            value: "",
            visible: false,
            content: "888",
            type: "score"
          },
          {
            name: "品牌卡余额",
            key: "brandCardBalance",
            value: "",
            visible: false,
            content: "￥998",
            type: "money"
          },
          {
            name: "品牌卡数量",
            key: "brandCardNum",
            value: "",
            visible: false,
            content: "3",
            type: "score"
          }
        ],
        plusStartShow: true,
        plusStartDesc: "",
        plusStartDescColor: "#8A4C13"
      },
      pageType: "",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      currentIndex: "",
      predefine,
      showPageSetting: true,
      dialogVisible: false,
      show: false,
      title: "个人中心",
      hotWord: "",
      activePreviewIndex: "",
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      hmComponents,
      allComponents: [],
      previewComponents: [
        {
          label: "我的订单",
          component: "orderList",
          prop: {
            name: "orderList"
          }
        },
        {
          label: "广告位",
          component: "banner",
          prop: {
            name: "banner",
            imgList: []
          }
        },
        {
          label: "加入微信群聊",
          component: "joinGroup",
          prop: {
            name: "joinGroup",
            show: true,
            bg:
              "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/3be3fd8810876be51a4a9cacc905b5b.png"
          }
        },
        {
          label: "我的服务",
          component: "myService",
          prop: {
            name: "myService",
            isVertical: false,
            serviceList: [
              {
                name: "积分商城",
                hrefAddress: "/activity/integral/integralIndex",
                icon:
                  "https://imgcdn.hemiao100.com/hemiaoBase/%E7%A7%AF%E5%88%86%E5%95%86%E5%9F%8E.png",
                show: true
              },
              {
                name: "优惠券",
                icon:
                  "https://imgcdn.hemiao100.com/hemiaoBase/%E4%BC%98%E6%83%A0%E5%88%B8.png",
                hrefAddress: "/pages/coupon/coupon",
                show: true
              },
              {
                name: "签到有礼",
                icon:
                  "https://imgcdn.hemiao100.com/hemiaoBase/%E7%AD%BE%E5%88%B0%E6%9C%89%E7%A4%BC.png",
                hrefAddress: "/checkIn/checkIn",
                show: true
              },
              {
                name: "推金库",
                icon:
                  "https://imgcdn.hemiao100.com/hemiaoBase/%E6%88%91%E7%9A%84%E5%88%86%E9%94%80.png",
                hrefAddress: "/promotionMember/income",
                show: true
              },
              // {
              //   name: "家庭档案",
              //   icon:
              //     "https://imgcdn.hemiao100.com/hemiaoBase/%E5%AE%B6%E5%BA%AD%E6%A1%A3%E6%A1%88.png",
              //   hrefAddress: "",
              //   show: true
              // },
              // {
              //   name: "线下订单",
              //   hrefAddress: "",
              //   icon:
              //     "https://imgcdn.hemiao100.com/hemiaoBase/%E7%BA%BF%E4%B8%8B%E8%AE%A2%E5%8D%95.png",
              //   show: true
              // },
              {
                name: "收货地址",
                hrefAddress: "/address/address",
                icon:
                  "https://imgcdn.hemiao100.com/hemiaoBase/%E6%94%B6%E8%B4%A7%E5%9C%B0%E5%9D%80.png",
                show: true
              }
            ]
          }
        }
      ],
      currentLinkIndex: "",
      currentLinkPropName: "",
      selectOrderList:[
        {
          src: "",
          state: "createOrder",
          hrefName: "待付款",
          hrefAddress: "/pages/order/order?orderState=createOrder",
        },
        {
          src: "",
          state: "payOrder",
          hrefName: "待发货",
          hrefAddress: "/pages/order/order?orderState=payOrder",
        },
        {
          src: "",
          state: "deliverOrder",
          hrefName: "待收货",
          hrefAddress: "/pages/order/order?orderState=deliverOrder",
        },
        {
          src: "",
          state: "returnOrder",
          hrefName: "售后",
          hrefAddress: "/article/refundList?type=1",
        },
        {
          src: "",
          state: "offlineOrder",
          hrefName: "线下订单",
          hrefAddress: "/pages/order/order?orderType=offlineOrder",
          isShow: false,
        },
      ],
    };
  },
  computed: mapGetters(["tempDetails", "microShopRouteList"]),
  watch: {
    tempDetails(val) {
      this.title = val.pageTitle || "个人中心";
      this.previewComponents = val.previewComponents
        ? JSON.parse(val.previewComponents)
        : this.previewComponents;
      console.log("this.previewComponents:",this.previewComponents);
      if (this.previewComponents) {
        this.previewComponents.forEach(v => {
          if (
            v.component === "myService" &&
            v.prop.serviceList.findIndex(
              o => o.hrefAddress === "customerService"
            ) === -1
          ) {
            v.prop.serviceList.unshift({
              name: "客户服务",
              icon: "https://imgcdn.hemiao100.com/hemiaoBase/kefu.png",
              hrefAddress: "customerService",
              show: false,
              custom: false
            });
          }
        });
        if(this.previewComponents.findIndex(o => o.component === "orderList") === -1){
          console.log("没有orderList");
          this.previewComponents.unshift(
            {
              label: "我的订单",
              component: "orderList",
              prop: {
                name: "orderList",
                orderList:[
                  {
                    src: "https://imgcdn.hemiao100.com/hemiaoBase/decoration/icon-createOrder.png",
                    state: "createOrder",
                    hrefName: "待付款",
                    hrefAddress: "/pages/order/order?orderState=createOrder",
                  },
                  {
                    src: "https://imgcdn.hemiao100.com/hemiaoBase/decoration/icon-payOrder.png",
                    state: "payOrder",
                    hrefName: "待发货",
                    hrefAddress: "/pages/order/order?orderState=payOrder",
                  },
                  {
                    src: "https://imgcdn.hemiao100.com/hemiaoBase/decoration/icon-deliverOrder.png",
                    state: "deliverOrder",
                    hrefName: "待收货",
                    hrefAddress: "/pages/order/order?orderState=deliverOrder",
                  },
                  {
                    src: "https://imgcdn.hemiao100.com/hemiaoBase/decoration/icon-refund.png",
                    state: "returnOrder",
                    hrefName: "售后",
                    hrefAddress: "/article/refundList?type=1",
                  },
                  {
                    src: "https://imgcdn.hemiao100.com/hemiaoBase/decoration/icon-offlineOrder.png",
                    state: "offlineOrder",
                    hrefName: "线下订单",
                    hrefAddress: "/pages/order/order?orderType=offlineOrder",
                    isShow: false,
                  },
                ]
              }
            }
          )
        }
      }
      if (
        this.previewComponents.findIndex(v => v.component === "joinGroup") ===
        -1
      ) {
        this.previewComponents.splice(1, 0, {
          label: "加入微信群聊",
          component: "joinGroup",
          prop: {
            name: "joinGroup",
            show: true,
            bg:
              "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/3be3fd8810876be51a4a9cacc905b5b.png"
          }
        });
      }
      if (val.tabBarList) {
        const tabBarList = JSON.parse(val.tabBarList);

        if (!tabBarList.hasOwnProperty("showCard")) {
          tabBarList.showCard = true;
        }
        if (!tabBarList.hasOwnProperty("showCardNo")) {
          tabBarList.showCardNo = true;
        }
        if (!tabBarList.hasOwnProperty("showPhone")) {
          tabBarList.showPhone = true;
        }
        if (!tabBarList.hasOwnProperty("showBrandCardBalance")) {
          tabBarList.showBrandCardBalance = false;
        }
        if (!tabBarList.hasOwnProperty("showBrandCardCount")) {
          tabBarList.showBrandCardCount = false;
        }
        if (!tabBarList.hasOwnProperty("showJoinGroup")) {
          tabBarList.showJoinGroup = false;
          tabBarList.joinGroupBg =
            "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/3be3fd8810876be51a4a9cacc905b5b.png";
        }
        if (!tabBarList.basInfoList) {
          tabBarList.basInfoList = this.tabBarList.basInfoList;
        }
        this.tabBarList.basInfoList.forEach(v => {
          tabBarList.basInfoList.forEach(j => {
            if (v.key === j.key) {
              Object.assign(v, j);
            }
          });
        });

        for (let key in this.tabBarList) {
          if (key !== "basInfoList") {
            this.tabBarList[key] = tabBarList[key];
          }
        }
      }
    },
    "currentProp.goodShowType": {
      handler(val) {
        if (val) {
          switch (val) {
            case "big":
              this.type = "大图";
              break;
            case "twoColumn":
              this.type = "一行两个";
              break;
            case "scroll":
              this.type = "横向滑动";
              break;
            default:
              break;
          }
        }
      },
      deep: true
    },
    "currentProp.permutation": {
      handler(val) {
        if (val) {
          this.calcCubeList(val);
        }
      },
      deep: true
    },
    "currentProp.type": {
      handler(val) {
        if (val) {
          this.currentProp.url = "";
        }
      },
      deep: true
    },
    "currentProp.isSwiper": {
      handler(val) {
        if (val) {
          this.currentProp.marginBottom = 0;
        }
      },
      deep: true
    }
  },
  created() {
    this.pageType = this.$route.query.pageType;
    this.pageModel = this.$route.query.pageModel;
    this.layoutId = this.$route.query.layoutId;
    this.mode = this.$route.query.mode;
    if (
      (this.pageModel === "customize" && this.layoutId) ||
      this.pageModel === "default"
    ) {
      this.$store.dispatch("queryTempDetails", {
        pageType: this.pageType,
        pageModel: this.pageModel,
        layoutId: this.layoutId
      });
    }
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page"
    });
  },
  methods: {
    handleCloseGroup(i) {
      this.currentProp.imgList[i].groupGoods = {};
      this.currentProp.imgList[i].hrefAddress = "";
    },
    saveGroupGoods(row) {
      this.currentProp.imgList[this.currentIndex].groupGoods = row;
      this.groupGoodsVisible = false;
    },
    selectGroup(e, i) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        this.currentIndex = i;
      }
    },
    deleteCurrentService(i) {
      this.currentProp.serviceList.splice(i, 1);
    },
    addServiceList() {
      this.currentProp.serviceList.push({
        name: "自定义标题",
        icon:
          "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/QQ%E6%88%AA%E5%9B%BE20191025165251.png",
        hrefAddress: "",
        show: true,
        custom: true
      });
    },
    setLink(row) {
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].goodsInfo = row;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      } else {
        this.currentProp.goodsInfo = row;
        this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    handleClose(v) {
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.pageType = "";
    },
    openGoodsSelect(v, i, propName) {
      if (v.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.groupGoods = {};
    },
    openGoodsSelectSingle() {
      if (this.currentProp.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
    },
    handleCloseSingle() {
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.pageType = "";
    },
    addGoods() {
      this.dialogVisible = true;
      this.isRadio = false;
    },
    saveGoods(data) {
      this.dialogVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        v => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    deleteCurrentGoods(i) {
      this.currentProp.goodsList.splice(i, 1);
      if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
        this.currentProp.goodsList.push({
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        });
      }
    },
    addHotWord() {
      this.currentProp.hotWordList.push({
        word: ""
      });
    },
    setPlaceholder() {
      if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
      }
    },
    save() {
      html2canvas(document.querySelector(".preview-wrapper"), {
        useCORS: true,
        backgroundColor: null
      }).then(canvas => {
        const previewImg = canvas.toDataURL("image/png");
        const params = {
          pageType: this.pageType,
          pageTitle: this.title,
          tabBarList: JSON.stringify(this.tabBarList),
          previewComponents: JSON.stringify(this.previewComponents),
          previewImg
        };
        let actionName = "";
        if (this.pageModel === "default") {
          actionName = "addTemp";
        } else {
          if (this.mode === "edit") {
            Object.assign(params, {
              micropageId: this.layoutId
            });
            actionName = "editTemp";
          } else {
            actionName = "addCustomTemp";
          }
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功！"
            });
            this.$router.back(-1);
          }
        });
      });
    },
    back() {
      this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$router.back();
      });
    },
    deleteCardList(i, prop) {
      this.currentProp[prop].splice(i, 1);
    },
    uploadPlusBg(type) {
      this.uploadType = "plusBg";
      this.uploadWidth = 1300;
      this.uploadHeight = 360;
      if (type === "joinGroupBg") {
        this.uploadType = type;
        this.uploadWidth = 690;
        this.uploadHeight = 96;
      }
      this.show = true;
    },
    openPageSetting() {
      this.currentProp = {};
      this.activePreviewIndex = "";
      this.showPageSetting = true;
    },
    uploadServiceImg(i) {
      this.uploadType = "serviceImg";
      this.uploadWidth = 76;
      this.uploadHeight = 76;
      this.show = true;
      this.currentImageAd = i;
    },
    selectPreviewItem(i, prop) {
      this.activePreviewIndex = i;
      this.currentProp = {};
      this.currentProp = prop;
      this.showPageSetting = false;
    },
    cropSuccess() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 添加底部导航栏
    addBannnerImg() {
      this.uploadType = "banner";
      this.uploadWidth = 1380;
      this.uploadHeight = 304;
      this.show = true;
    },
    deleteCurrentImageAd(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    calcCubeList(val) {
      let length = this.currentProp.cubeList
        ? this.currentProp.cubeList.length
        : 0;
      let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
      if (val < length) {
        list = list.slice(0, val);
      } else if (val > length) {
        for (let i = 0; i < val - length; i++) {
          list.push({
            src:
              "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            url: ""
          });
        }
      }
      this.currentProp.cubeList = list;
    },
    deleteCurrentBanner(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    changeImageAd(i) {
      this.uploadWidth = 690;
      this.uploadHeight = 152;
      this.show = true;
      this.uploadType = "banner";
      this.currentImageAd = i;
    },
    changeImageOrder(i){
      this.uploadWidth = 76;
      this.uploadHeight = 76;
      this.show = true;
      this.uploadType = "orderList";
      this.currentImageAd = i;
    },
    addImageAd() {
      this.currentProp.imgList.push({
        src:
          "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
        hrefAddress: "",
        text: "",
        goodsInfo: {},
        groupGoods: {}
      });
    },
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      switch (this.uploadType) {
        case "plusBg":
          this.tabBarList.plusBg = url;
          break;
        case "joinGroupBg":
          this.tabBarList.joinGroupBg = url;
          break;
        case "banner":
          this.currentProp.imgList[this.currentImageAd].src = url;
          break;
        case "serviceImg":
          this.currentProp.serviceList[this.currentImageAd].icon = url;
          break;
        case "orderList":
          this.currentProp.orderList[this.currentImageAd].src = url;
          break;          
        default:
          break;
      }
    },
    deleteCurrentTab(i) {
      this.tabBarList.splice(i, i);
    },
    cropUploadFail() {}
  }
};
</script>
<style lang="scss">
.user-center-temp-container {
  .el-carousel__indicators {
    display: none;
  }
  .other-setting {
    .radio-wrapper {
      padding: 0 20px;
      margin-bottom: 20px;
      .sub-title {
        margin-bottom: 0 !important;
      }
    }
    .el-radio-group {
      border: 1px solid #ddd;
      border-radius: 5px;
      height: 30px;
      display: flex;
      .el-radio {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio.is-checked {
        background: #ffeaf3;
      }
      .el-radio {
        margin-right: 0;
        width: 48px;
        height: 30px;
        .hmicon {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.user-center-temp-container {
  .component-list {
    background: #fff;
    padding: 20px;
    width: 219px;
    box-sizing: border-box;
    cursor: not-allowed;
    .title {
      color: #ccc;
      font-size: 16px;
      margin-bottom: 31px;
    }
    .list-group {
      box-sizing: border-box;
    }
    .list-group-item {
      cursor: not-allowed;
      margin-bottom: 28px;
      width: 50%;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      .hmicon {
        font-size: 24px;
      }
      .label {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .preview-container {
    position: absolute;
    top: 220px;
    left: 219px;
    right: 360px;
    bottom: 0;
    user-select: none;
  }
  .preview-wrapper {
    position: relative;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    width: 375px;
    height: 667px;
    margin: 0 auto;
    .preview-head {
      height: 64px;
      width: 375px;
      margin: 0 auto;
      background: url("https://imgcdn.hemiao100.com/hemiaoBase/download.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .preview-title {
        width: 180px;
        margin: 0 auto;
        height: 34px;
        line-height: 26px;
        text-align: center;
        padding-top: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .preview-body {
      position: relative;
      .radius {
        position: absolute;
        top: 207px;
        z-index: 100;
      }
      .preview-list-group {
        position: relative;
        height: 553px;
        margin-bottom: 50px;
        .preview-list-group-item {
          .orderList-wrapper{
            background: #ffffff;
            margin: 15px;
            padding: 10px;
            font-size: 14px;
            .orderList-title{
              font-weight: 600;
              color: #2B2B2B;
            }
            .orderList-subtitle{
              color: #999999;
            }
          }
          .orderList-item{
            padding-top: 26px;
            .orderList-src{
              width: 32px;
              height: 32px;
              padding-bottom: 10px;
            }
          }
          .orderList-offlineOrder{
            padding: 10px;
            height: 40px;
            background: #F8F8F8;
            margin-top: 24px;
            .orderList-src{
              width: 32px;
              height: 32px;
              padding-right: 10px;
            }
          }
          box-sizing: border-box;
          border: 2px solid transparent;
          .widget {
            position: absolute;
            top: 0;
            right: -40px;
            width: 34px;
            .widget-label {
              display: inline-block;
              background-color: #fff;
              width: 80px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-size: 12px;
              pointer-events: none;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-width: 5px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
              position: absolute;
              bottom: 7px;
              left: -10px;
            }
          }
          *:not(.widget-icon) {
            cursor: move !important;
          }
          video {
            height: 210px;
            width: 100%;
            display: block;
          }
          &:last-child {
            margin-bottom: 50px;
          }
          &.active,
          &.active:hover {
            box-sizing: border-box;
            border: 2px solid #ea5798;
            cursor: move;
          }
          &:hover {
            box-sizing: border-box;
            border: 2px dashed #ea5798;
            cursor: move;
          }
        }

        .contact-us-item {
          position: absolute;
          bottom: 23px;
          width: 100%;
          z-index: 11;
          left: 0;
        }
        .list-group-item {
          transition: all 0.2s linear;
          background-color: #fddfeb !important;
          border-radius: 2px;
          color: #e2005d;
          text-align: center;
          .label {
            margin-top: 10px;
          }
        }
      }
      .preview-height-tag {
        position: absolute;
        left: -130px;
        bottom: 0;
        width: 130px;
        display: -ms-flexbox;
        display: flex;
        color: #a2a2a2;
        border-bottom: 1px solid #dedede;
        .preview-height-tag-text {
          padding-top: 4px;
          font-size: 12px;
        }
      }
    }
  }

  .options-container {
    width: 360px;
    position: absolute;
    top: 56px;
    box-sizing: border-box;
    padding-bottom: 100px;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    bottom: 0;
    background: #fff;
    .p20 {
      padding: 20px;
    }
    .have-bg-wrapper {
      padding: 0 20px 20px;
      background: #fafafa;
    }
    .title {
      color: #2b2b2b;
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .tips {
      margin: 18px 0 20px;
      font-size: 12px;
      color: #777;
    }
    .sub-title {
      color: #2b2b2b;
      margin-bottom: 20px;
    }
    .page-header {
      padding: 20px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .page-footer {
      font-size: 14px;
      .sub-title {
        background: #fff;
        padding: 20px;
      }
    }
  }

  .border-bottom {
    border-bottom: 1px solid #eee;
  }

  .page-setting {
    .tabbar-setting .tabbar-setting-item .icon-wrapper {
      img {
        width: 21px;
      }
    }
  }

  .page-setting-btn {
    position: absolute;
    right: 385px;
    top: 100px;
    width: 98px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    border-radius: 2px;
    line-height: 36px;
    cursor: pointer;
    user-select: none;
    &.active {
      background: #e2005d;
      color: #fff;
      .hmicon {
        color: #fff;
      }
    }
    .hmicon {
      margin-right: 5px;
    }
  }
  .temp-header {
    height: 56px;
    line-height: 56px;
    background: #e50065;
    color: #fff;
    padding: 0 22px;
    font-size: 16px;
    user-select: none;
    .hmicon {
      color: #fff;
      font-size: 18px;
      margin-right: 10px;
    }
    .btn {
      cursor: pointer;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 14px;
    }
    .header-list {
      li {
        border-right: 1px solid #fff;
        padding: 0 22px;
      }
      li:last-child {
        padding-right: 0;
        border-right: 0;
      }
    }
  }
  .tabbar-setting {
    background: #fafafa;
    padding: 20px;
    .tabbar-setting-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      .delete-tab {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
      &:hover {
        .delete-tab {
          opacity: 1;
        }
      }
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          max-width: 36px;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
  .card-list {
    .card-list-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;

      &:hover {
        .card-item-delete {
          opacity: 1;
        }
      }
      .card-item-delete {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
    }
  }
}

.info {
  position: relative;
  .white-bg {
    position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    width: 100px;
    height: 31px;
  }
  .white-bg-type {
    position: absolute;
    top: 9px;
    left: 138px;
    background: #fff;
    width: 80px;
    height: 36px;
  }
}

.other-setting {
  font-size: 14px;
  li {
    margin-bottom: 20px;
    div {
      span:first-child {
        display: inline-block;
        width: 80px;
      }
      .sub-title {
        font-weight: bold;
      }
    }
  }
}
.plus-bg-wrapper {
  position: relative;
  margin: 0 auto;
  width: 300px;
  padding-top: 20px;
  &.join-bg {
    img {
      min-height: auto;
    }
  }
  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
    min-height: 150px;
  }
  .tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }
}

.tabbar {
  // position: absolute;
  margin: 0;
  padding: 0;
  left: 0;
  bottom: 0;
  z-index: 31;
  box-sizing: border-box;
  width: 100%;
  height: 49px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.img {
  width: 100%;
}

.member-info {
  background: #fff;
  overflow: hidden;
  height: 170px;
  position: relative;
  &.no-card {
    height: auto;
  }
  .info {
    text-align: center;
    .name {
      font-size: 14px;
      color: #999;
    }
  }
  .member-card {
    position: relative;
    padding: 0 15px;
    button {
      position: absolute;
      top: 33px;
      right: 20px;
      background: linear-gradient( 270deg, #F2C767 0%, #EB9C4D 100%);
      border: none;
      border-radius: 30px;
      padding: 5px;
      font-size: 12px;
      outline: 0;
      padding: 8px 10px;
      color: #fff;
      letter-spacing: 1px;
    }
    img {
      border-radius: 5px;
    }
    .plus-start-day {
      position: absolute;
      top: 10px;
      left: 26px;
      height: 22px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 500;
      font-size: 16px;
      color: #8A4C13;
      line-height: 19px;
    }
  }
  .info {
    padding: 15px 0;
  }
}

.order-list {
  padding: 15px;
  .img {
    border-radius: 3px;
  }
}

.banner-wrapper {
  .img {
    padding: 0 15px;
    width: calc(100% - 30px);
  }
}

.service-list-card {
  background: #fff;
  border-radius: 3px;
  margin: 15px;
  font-size: 14px;
  &::before {
    display: table;
    content: "";
  }
  .title {
    margin: 20px 10px;
    font-size: 16px;
  }
  &.vertical {
    .service-list {
      display: unset;
      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 0;
        .icon-wrapper {
          display: flex;
          align-items: center;
        }
        .hmicon {
          font-size: 14px;
        }
        .icon {
          width: 15px;
          height: auto;
          margin-right: 10px;
        }
      }
    }
  }
  .service-list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      flex-basis: 25%;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
      .icon {
        height: 30px;
        width: auto;
      }
    }
  }
}

.add-navigation {
  padding: 0 20px;
}

.mb50 {
  margin-bottom: 50px;
}

.join-group-wrapper {
  img {
    margin: 15px 15px 0;
    width: calc(100% - 30px);
    display: block;
  }
}

.info-img-wrapper {
  position: relative;
  .card-no {
    position: absolute;
    top: 49px;
    left: 100px;
    width: 200px;
    height: 60px;
    font-size: 12px;
    background: #fff;
    color: #666;
  }
}
</style>
